"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=asNumeral.js.map